import { render } from "./MyShiftsDataTable.vue?vue&type=template&id=6b4e9f50"
import script from "./MyShiftsDataTable.vue?vue&type=script&lang=js"
export * from "./MyShiftsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__